import {
  getRouterSitemapCount as publicGetRouterSitemapCount,
  getRouterSitemap as publicGetRouterSitemap,
  getRouterPages as publicGetRouterPages,
  getRouterPagesCached as publicGetRouterPagesCached,
  getDraftPreviewToken as publicGetDraftPreviewToken,
} from './dynamic-page-router-v1-page-pages.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getRouterSitemapCount: MaybeContext<
  BuildRESTFunction<typeof publicGetRouterSitemapCount> &
    typeof publicGetRouterSitemapCount
> = /*#__PURE__*/ createRESTModule(publicGetRouterSitemapCount);
export const getRouterSitemap: MaybeContext<
  BuildRESTFunction<typeof publicGetRouterSitemap> &
    typeof publicGetRouterSitemap
> = /*#__PURE__*/ createRESTModule(publicGetRouterSitemap);
export const getRouterPages: MaybeContext<
  BuildRESTFunction<typeof publicGetRouterPages> & typeof publicGetRouterPages
> = /*#__PURE__*/ createRESTModule(publicGetRouterPages);
export const getRouterPagesCached: MaybeContext<
  BuildRESTFunction<typeof publicGetRouterPagesCached> &
    typeof publicGetRouterPagesCached
> = /*#__PURE__*/ createRESTModule(publicGetRouterPagesCached);
export const getDraftPreviewToken: MaybeContext<
  BuildRESTFunction<typeof publicGetDraftPreviewToken> &
    typeof publicGetDraftPreviewToken
> = /*#__PURE__*/ createRESTModule(publicGetDraftPreviewToken);

export {
  Page,
  GetRouterSitemapCountRequest,
  Config,
  Pattern,
  PatternConfig,
  PageRule,
  PageRole,
  GetRouterSitemapCountResponse,
  RouterCountItem,
  GetRouterSitemapRequest,
  GetRouterSitemapResponse,
  RouterRouteItem,
  GetRouterPagesRequest,
  RequestInfo,
  GetRouterPagesResponse,
  RouterPagesResult,
  RouterPageHead,
  GetRouterPagesCachedRequest,
  GetRouterPagesCachedUrlParams,
  GetDraftPreviewTokenRequest,
  GetDraftPreviewTokenResponse,
  GetRouterSitemapCountOptions,
  GetRouterSitemapOptions,
  GetRouterPagesOptions,
  GetRouterPagesCachedOptions,
  GetDraftPreviewTokenOptions,
} from './dynamic-page-router-v1-page-pages.universal.js';
